const WorklistItemStatusEnum = {
    UNSCHEDULED: {
        value: 0,
        label: 'UNSCHEDULED',
        color: '#d9d9d9',
        tagColor: 'default'
    },
    SCHEDULED: {
        value: 1,
        label: 'SCHEDULED',
        color: '#f1c40f',
        tagColor: 'blue'
    },
    ACCEPTED: {
        value: 2,
        label: 'ACCEPTED',
        color: '#52c41a',
        tagColor: 'green'
    },
    CANCELLED: {
        value: 3,
        label: 'CANCELLED',
        color: '#ff4d4f',
        tagColor: 'red'
    }
};

// Helper functions
export const getStatusByValue = (value) => {
    return Object.values(WorklistItemStatusEnum).find(status => status.value === value);
};

export const getStatusColor = (value) => {
    const status = getStatusByValue(value);
    return status ? status.color : '#d9d9d9';
};

export const getStatusTagColor = (value) => {
    const status = getStatusByValue(value);
    return status ? status.tagColor : 'default';
};

export const getStatusLabel = (value) => {
    const status = getStatusByValue(value);
    return status ? status.label : 'Unknown';
};

export const getStatusOptions = (excludeValue = null) => {
    return Object.values(WorklistItemStatusEnum)
        .filter(status => excludeValue === null || status.value !== excludeValue)
        .map(status => ({
            label: status.label,
            value: status.value
        }));
};

export default WorklistItemStatusEnum;
